import { Pipe, PipeTransform } from '@angular/core';
import { TimeBlockModel } from '../../../../../core/models/timeblock/time-block.model';
import { DateTimeHelper } from '../../../util/date-time-helper';
import { TimeBlockDurationCalculationService } from '../calculation/duration/time-block-duration-calculation.service';

@Pipe({
  name: 'timeBlockTimeDifference',
  standalone: false,
})
export class TimeBlockTimeDifferencePipe implements PipeTransform {
  transform(timeBlockModel: TimeBlockModel): string {
    const duration =
      TimeBlockDurationCalculationService.calculateTimeBlockDurationWithinDay(timeBlockModel);
    return DateTimeHelper.formatSecondsToHoursAndMinutes(duration);
  }
}
